import React from 'react';
import PropTypes from 'prop-types';
import RippleButton from './RippleButton';
import { getFullUrl, appendQueryString } from 'utils/utils';
import parse from 'html-react-parser';


const SectionShipOverview = ({ items, ctaConfig, shipNowUrl, shipNowButtonText, shipToUrl, 
  shipToButtonText, shipFromUrl, shipFromButtonText, name, partnerId, couponCode, children }) => {
  const brandSlug = window.gon.current_brand ? window.gon.current_brand : 'shipsticks';
  console.log('couponCode in SectionShipOverview:', couponCode);
  return (
    <div className="bg-white text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-16 w-full">
      <div className="flex flex-col gap-11 lg:flex-row justify-between max-w-7xl mx-auto">
        <div className="w-full lg:w-2/5">
          {children}
          <br />
          {ctaConfig == 'ship_now' && (
            console.log('couponCode in SectionShipOverview:', couponCode),
            <RippleButton
              onClick={() => { window.location.href = shipNowUrl ? 
                shipNowUrl : appendQueryString(getFullUrl('/ship', window.gon.subdomain), `coupon=${couponCode}`); }}
              className="
                flex items-center justify-center bg-[#231F20] text-white rounded-full
                px-5 py-8 my-6 h-[48px] w-full md:w-3/4 lg:w-1/2 lg:max-w-72 text-lg mx-auto lg:mx-0
              "
            >
              {shipNowUrl ? shipNowButtonText : 'Book Now'}
            </RippleButton>
          )}
          {(ctaConfig == 'ship_to' || ctaConfig == 'ship_to_and_from') && (
            <RippleButton
              onClick={() => { window.location.href = shipToUrl ? shipToUrl : appendQueryString(getFullUrl(
                `/ship?shipping_to=${partnerId}`, window.gon.subdomain) `coupon=${couponCode}`
              )}}
              className="
                flex items-center justify-center bg-[#231F20] text-white rounded-full
                px-5 py-8 my-6 h-[48px] w-full text-lg mx-auto lg:mx-0
              "
            >
              {shipToUrl ? shipToButtonText : `Ship To ${name}`}
            </RippleButton>
          )}
          {(ctaConfig == 'ship_from' || ctaConfig == 'ship_to_and_from') && (
            <RippleButton
              onClick={() => { window.location.href = shipFromUrl ? shipFromUrl : appendQueryString(getFullUrl(
                `/ship?shipping_from=${partnerId}`, window.gon.subdomain), `coupon=${couponCode}`
              )}}
              className="
                flex items-center justify-center bg-[#231F20] text-white rounded-full
                px-5 py-8 my-6 h-[48px] w-full text-lg mx-auto lg:mx-0
              "
            >
              {shipFromUrl ? shipFromButtonText : `Ship From ${name}`}
            </RippleButton>
          )}
        </div>

        <div className="w-full lg:w-3/5">
          {items.map((item, index) => (
            <div
              key={index}
              className="
                flex items-start w-full mb-4 bg-gray-100 px-8 py-8
                border border-gray-300 rounded-3xl shadow-sm
              ">
              <div className="flex-grow h-auto flex flex-col text-left items-start justify-start">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  <div className={`text-${brandSlug} font-bold inline-block text-3xl pr-4 shrink-0`}>
                    {`0${index+1}`}
                  </div>
                  {item.header}</h2>
                <div className="text-[18px] leading-[30px]">{parse(item.body)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SectionShipOverview.propTypes = {
  ctaConfig: PropTypes.string,
  shipNowUrl: PropTypes.string,
  shipNowButtonText: PropTypes.string,
  shipToUrl: PropTypes.string,
  shipToButtonText: PropTypes.string,
  shipFromUrl: PropTypes.string,
  shipFromButtonText: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
  partnerId: PropTypes.string,
  couponCode: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      body: PropTypes.string,
    })
  ),
};


export default SectionShipOverview;
